import React, { useContext } from 'react';

const CarouselContext = React.createContext();

export function useCarouselContext() {
  return useContext(CarouselContext);
}

export default CarouselContext;
